import React from 'react';
import PropTypes from 'prop-types';
import Experiment from '@homeaway/react-experiment';
import {GlobalInlineAlert} from '@homeaway/react-global-messaging';

export const TripDetailsInfobox = ({globalMessages}) => {
    return (
        <Experiment name={'vrbo_web_global_messaging_alert'} variant={'on'}>
            {globalMessages && (
                <section className="Content__section InfoBox">
                    <div className="wrapper">
                        <GlobalInlineAlert globalMessages={globalMessages} />
                    </div>
                </section>
            )}
        </Experiment>
    );
};

TripDetailsInfobox.propTypes = {
    globalMessages: PropTypes.shape({}),
};
